import axios from 'axios'

/**
 * 获取企业列表
 * @param data
 * @returns {Promise<any>}
 */
export async function getCompanyList() {
  const result = await axios.post('/userCenter/newcoreorg/company/listCompanyByAccount')
  return result.data
}
/**
 * 获取企业列表
 * @param data
 * @returns {Promise<any>}
 */
export async function getUserInfoNumber() {
  const result = await axios.post('/userCenter/home/personalDashboard')
  return result.data
}
/**
 * 新增企业
 * @param data
 * @returns {Promise<any>}
 */
export async function addCompany(data) {
  const result = await axios.post('/userCenter/newcoreorg/company/add', data)
  return result.data
}

/**
 * 获取企业的详情
 * @param data
 * @returns {Promise<any>}
 */
export async function getCompanyDetail(data) {
  const result = await axios.post('/ecoSystem/api/v1/neworg/company/detail', data)
  return result.data
}

/**
 * 查看ca证书
 * @param params
 * @returns {Promise<any>}
 */
export async function getCAInfo(data) {
  const result = await axios.post('/ecoSystem/api/v1/ca/info', data)
  return result.data
}

/**
 * 企业认证
 * @param data
 * @returns {Promise<any>}
 */
export async function getCompanyVerify(data) {
  let result = await axios.post('/ecoSystem/api/v1/neworg/company/verify', data)
  return result.data
}

/**
 * 更新企业信息
 * @param data
 * @returns {Promise<any>}
 */
export async function companyUpdate(data) {
  let result = await axios.post('/ecoSystem/neworg/company/update', data)
  return result.data
}

/**
 * 修改企业名称
 * @param data
 * @return {Promise<any>}
 */
export async function companyUpdateName(data) {
  let result = await axios.post('/ecoSystem/newcoreorg/company/updateName', data)
  return result.data
}
/**
 * 上传企业logo
 * @param data
 * @returns {Promise<any>}
 */
export async function changeCompanyLogo(data) {
  let result = await axios.post('/ecoSystem/api/v1/neworg/updateCompanyLogo', data)
  return result.data
}

/**
 * 设置常用企业
 * @param data
 * @returns {Promise<any>}
 */
export async function setCommonCompany(data) {
  let result = await axios.post('/userCenter/newcoreorg/company/setUseCompanyFlg', data)
  return result.data
}

/**
 * 更换管理员获取验证码接口
 * @param data
 * @returns {Promise<any>}
 */
export async function sendChangeMangerSmsCode(data) {
  let result = await axios.post('/userCenter/newcoreorg/company/sendChangeMangerSmsCode', data)
  return result.data
}

/**
 * 更换管理员提交信息（包含最后一步短信校验）
 * @param data
 * @returns {Promise<any>}
 */
export async function submitChangeMangerInfo(data) {
  let result = await axios.post('/userCenter/newcoreorg/company/submitChangeMangerInfo', data)
  return result.data
}

/**
 * 版本升级，获取手机验证码
 */
export async function sendSmsCode(mobile) {
  let result = await axios.post('/ecoSystem/api/v1/temp/upgrade/send-sms-code', {
    mobile
  })
  return result.data
}

/**
 * 版本升级，校验手机验证码
 */
export async function codeVerify(data) {
  let result = await axios.post('/ecoSystem/api/v1/temp/upgrade/code-verify', data)
  return result.data
}

/**
 * 提交升级
 */
export async function upgrade(data) {
  let result = await axios.post('/ecoSystem/api/v1/temp/upgrade/upgrade', data)
  return result.data
}

/**
 * 免登
 */
export async function getUcToken(data) {
  let result = await axios.post('/ecoSystem/api/v1/temp/upgrade/get-uc-token', data)
  return result.data
}

/**
 * 免登2
 */
export async function getNewToken(data) {
  let result = await axios.post('/ecoSystem/api/v1/temp/upgrade/get-new-token', data)
  return result.data
}
